const riot = require('riot');

riot.tag2('popup-calendar', '<div class="w252 p12 bg-white rounded-4 box-shadow" ref="popup"> <div data-is="module-calendar-mini" start-date="{opts.startDate}"></div> </div>', '', '', function(opts) {
});